module.exports = __webpack_public_path__ + "media/24.f26260cf.wav";